<mat-dialog-content>
    <kiene-kiene-table [tableDescriptor]="tableDescriptor"></kiene-kiene-table>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-flat-button (click)="dialogRef.close()" color="accent">Schließen</button>
</mat-dialog-actions>
